<div class="content">
  <div class="row mx-0">
    <div class="col-7 px-0 text-start">
      <h3>My Consult Notes</h3>
    </div>
    <div class="col-5 no-padding">
      <app-user-stats />
    </div>
  </div>

  @if (canAssignUser) {
    <app-consult-note-queue-assign-user
      [enabled]="hasConsultNoteSelection"
      [selectedCount]="consultNoteSelectionCount"
      (assignUser)="handleAssignUser($event)"
      (clearSelection)="handleClearSelection()"
      [hideOnNoSelection]="false"
      [totalCount]="resultCount"
      />
  }
  @if (!loadingResults) {
    <div class="mt-2">
      @if (consultNoteQueueResults.length > 0) {
        <div>
          <app-consult-note-queue-results
            [consultNoteQueueResults]="consultNoteQueueResults"
            [selectedConsultNoteIds]="selectedConsultNoteIds"
            (selectionChanged)="handleSelectionChange($event)"
            [canAssignUser]="canAssignUser"
            [myWorkQueue]="true"
            />
          @if (hasMoreResults) {
            <div class="text-center mb-4">
              <a href="#next" (click)="onNextClick($event)" class="load-next-consult-notes">
                View Next {{ limit }} Consult Notes
              </a>
            </div>
          }
        </div>
      } @else {
        <p class="mt-2 ms-1">No consult notes found. Try modifying the filters.</p>
      }
    </div>
  } @else {
    <div class="mt-2 ms-1"><mat-spinner diameter="30" /></div>
  }
</div>
